import Keyboard from 'simple-keyboard'
import 'simple-keyboard/build/css/index.css'

let keyboardInstance = null

export default function showQAOverlay() {
    const overlay = document.getElementById('qaOverlay')
    const input = document.getElementById('qaInput')
    const submitBtn = document.getElementById('qaSubmitBtn')
    const closeBtn = document.getElementById('qaCloseBtn')

    // Anzeigen
    overlay.classList.remove('hidden')

    // Vorherige Antwort laden
    const savedAnswer = localStorage.getItem('qa_answer')
    if (savedAnswer) {
        input.value = savedAnswer
        if (keyboardInstance) {
            keyboardInstance.setInput(savedAnswer)
        }
    }

    // Tastatur nur einmal erstellen
    if (!keyboardInstance) {
        keyboardInstance = new Keyboard({
            onChange: inputValue => {
                input.value = inputValue
            },
            onKeyPress: button => {
                if (button === "{bksp}") {
                    const current = input.value
                    input.value = current.substring(0, current.length - 1)
                    keyboardInstance.setInput(input.value)
                }
            },
            layout: {
                default: [
                    'Q W E R T Z U I O P',
                    'A S D F G H J K L',
                    'Y X C V B N M',
                    '{space} {bksp}'
                ]
            },
            display: {
                '{bksp}': '⌫',
                '{space}': '␣'
            }
        })
    }

    // Speichern
    submitBtn.onclick = () => {
        localStorage.setItem('qa_answer', input.value)
       // alert('Antwort gespeichert: ' + input.value)
        overlay.classList.add('hidden')
    }

    // Schließen
    closeBtn.onclick = () => {
        overlay.classList.add('hidden')
    }
}
